import { FunctionComponent } from 'react';
import { ViewProps } from './types';
import { Page, Footer, Navigation, Link } from './styles';

const View: FunctionComponent<ViewProps> = ({ children }) => (
  <Page className="Page">
    {children}
    <Footer>
      <Navigation>
        <Link to="/imprint">Imprint</Link>
        <Link to="/privacy">Privacy</Link>
      </Navigation>
    </Footer>
  </Page>
);

export default View;
